import React from "react";
import { connect } from "react-redux";
import { SetTerm, SetDays } from "./store";
import moment from "moment";


export function AcademyGroup(props) {

    let discountMessage = null;
    if(props.discount){
        let cutoffMessage = null;
        if(props.discount.cutoff){
            cutoffMessage = ` - Offer ends ${moment(props.discount.cutoff).format("Do MMMM")}`
        }
        if(props.discount.type == "early"){
            if(cutoffMessage == null) {
                discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Book Now!</span>
            } else {
                discountMessage = <span className="discount-message"><strong>{props.discount.discount}% OFF</strong> Early Bird{cutoffMessage}</span>
            }
        }
        if(props.discount.type == "consecutive"){
            discountMessage = <span className="discount-message"><strong>{props.discount.discount}% Off</strong> Full Week Bookings{cutoffMessage}</span>
        }

        if(props.discount.type == "sibling"){
            discountMessage = <span className="discount-message"><strong>{props.discount.discount}% Off</strong> Full Week Bookings{cutoffMessage}</span>
        }
    }
    return <div>
        <div className="input-group term-selector">
            <input type="checkbox" name="course-options" id={`choose-days-${props.idx}`} value="choose-days" checked={props.isOpen} onChange={() => {
                if (props.isOpen) {
                    props.close();
                } else {
                    props.open();
                }
            }} />
            <label htmlFor={`choose-days-${props.idx}`} >
                {props.label}
                <span>{new Date(props.from).format("l j F")} - {new Date(props.to).format("l j F")}</span>
                <span>{props.days.length} Session{props.days.length != 1 ? "s" : ""} (&pound;{(props.perDay * props.days.length).toFixed(2)})</span>
                {discountMessage}
            </label>
        </div>
        <div className="table-container" style={{ display: props.isOpen ? "" : "none" }}>
            <table>
                <tbody>
                    {props.days.map(d =>
                        <tr key={d}>
                            <td className="remaining-date">{new Date(d).format("l j F")}</td>
                            <td className="date-cost">&pound; {props.perDay}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {(() => {
                if (props.isOpen) {
                    return props.days.map(d => props.types.map(t => <input key={t} type="hidden" name={`booked-date[${t}][]`} value={d} />))
                }
            })()}
        </div>
    </div>
}
export default connect((state, ownProps) => ({
    isOpen: !!state.term[ownProps.idx],
    isMobile: state.isMobile
}), (dispatch, ownProps) => ({
    open: () => {
        dispatch(SetTerm(ownProps.idx, ownProps.days));
        dispatch(SetDays(ownProps.days));
    },
    close: () => {
        dispatch(SetTerm(ownProps.idx, ownProps.days));
    }
}))(AcademyGroup)


// WEBPACK FOOTER //
// ./flexi/AcademyGroup.jsx